import { render, staticRenderFns } from "./MindsetImportDialog.vue?vue&type=template&id=6b92d6df&scoped=true&"
import script from "./MindsetImportDialog.vue?vue&type=script&lang=ts&"
export * from "./MindsetImportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b92d6df",
  null
  
)

export default component.exports